import React, { useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallback, { errorHandler } from '../ErrorFallback';
import { Sidenav } from './Sidenav';
import { useAppSelector } from '../../app/hooks';
import ApiErrorInfo from '../ApiErrorInfo';
import { selectStatusToasts, StatusToastContainer } from './StatusToast';
import { useAuthUser } from '../../features/auth/authHooks';

type LayoutProps = {
  children: React.ReactNode;
};

export const Layout = (props: LayoutProps) => {
  const { logoutUrl, loginFirstName, loginLastName, siteClaims, activeSite } =
    useAuthUser();

  const { children } = props;
  const toasts = useAppSelector(selectStatusToasts);

  let initials = loginFirstName ? loginFirstName.charAt(0).toUpperCase() : '';
  initials = loginLastName
    ? initials + loginLastName.charAt(0).toUpperCase()
    : '';

  const username = `${loginFirstName || ''} ${loginLastName || ''}`;

  const [hasError, setHasError] = React.useState(false);
  const apiError = useAppSelector(state => state.errors.apiError);

  const [isSidenavOpen, setIsSidenavOpen] = useState<boolean>(false);

  const handleSidenavOpen = (IsOpen: boolean) => {
    setIsSidenavOpen(IsOpen);
  };

  return (
    <>
      {apiError && (
        <ApiErrorInfo
          Source={apiError.Source}
          Exception={apiError.Exception}
          Message={apiError.Message}
          ErrorCode={apiError.ErrorCode}
          InfoBookingErrorId={apiError.InfoBookingErrorId}
        />
      )}
      <Sidenav
        HandleSidenavOpen={handleSidenavOpen}
        Initials={initials}
        LogoutUrl={logoutUrl}
        Username={username}
        SiteClaims={siteClaims}
        ActiveSite={activeSite}
      />
      <ErrorBoundary
        FallbackComponent={ErrorFallback}
        onError={errorHandler}
        onReset={() => setHasError(false)}
        resetKeys={[hasError]}
      >
        <main
          className={`main-content${
            isSidenavOpen ? ' main-content-noscroll' : ''
          } pb-48`}
        >
          {children}
        </main>
      </ErrorBoundary>
      <StatusToastContainer Toasts={toasts} />
    </>
  );
};
